import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountType } from "@front/m19-api-client";
import { AccountSelectionService } from "@front/m19-services";
import { TranslocoDirective } from "@jsverse/transloco";
import { GrantSellingPartnerAccessButtonComponent } from "@m19-board/shared/grant-selling-partner-access-button/grant-selling-partner-access-button.component";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-invalid-selling-partner-api-access-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, GrantSellingPartnerAccessButtonComponent],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="warning"
      icon="alertCircle"
      [title]="t('overlays.invalid_selling_partner_api_access_title', [sellerCentralName()])"
    >
      <p overlayBody>{{ t("overlays.invalid_selling_partner_api_access_reason", [sellerCentralName()]) }}</p>
      <p overlayBody>{{ t("overlays.invalid_selling_partner_api_access_action") }}</p>
      <app-grant-selling-partner-access-button
        overlayCta
        [label]="t('overlays.invalid_selling_partner_api_access_cta', [sellerCentralName()])"
      />
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvalidSellingPartnerApiAccessOverlayComponent {
  private readonly accountSelectionService = inject(AccountSelectionService);

  static readonly rule = OverlayRule.INVALID_SELLING_PARTNER_API_ACCESS;

  private readonly accountMarketplace = toSignal(this.accountSelectionService.singleAccountMarketplaceSelection$, {
    requireSync: true,
  });

  protected readonly sellerCentralName = computed(() =>
    this.accountMarketplace().accountType === AccountType.SELLER ? "Seller Central" : "Vendor Central",
  );
}
